"use client"

import Link from "next/link"
import { useTranslations } from "next-intl"

/**
 * SMS opt-in disclosure — sits directly under every phone field.
 *
 * Toll-free / A2P carrier review checks for exactly this at the point the
 * number is collected: brand, message type, frequency, rates, STOP/HELP, and
 * links to terms + privacy. The wording lives in messages/pages/sms.{en,es}.json
 * alongside /sms itself — the toll-free registration's opt-in proof points at
 * that page, and the two must say the same thing in the same language.
 *
 * These links deliberately do NOT open a new window. Inside the native shell a
 * new window leaves the app for Safari and the half-filled booking form is
 * gone. Same-origin links stay in the web view; see lib/native-open.ts.
 */
export function SmsConsent({ tone = "light", className = "" }: { tone?: "light" | "dark"; className?: string }) {
  const t = useTranslations("pages.sms")
  const text = tone === "dark" ? "text-neutral-500" : "text-muted-foreground"
  const link = tone === "dark" ? "underline hover:text-neutral-300" : "underline hover:text-foreground"
  return (
    <p className={`text-[10px] leading-snug ${text} ${className}`}>
      {t("consent")}{" "}
      <Link href="/terms" className={link}>
        {t("consentTerms")}
      </Link>{" "}
      &amp;{" "}
      <Link href="/privacy" className={link}>
        {t("consentPrivacy")}
      </Link>
      .
    </p>
  )
}
